import { APP_CONFIG } from 'services/app-config'

export const CONFIG = {
  api: {
    orderStatus: `${APP_CONFIG.apigee_host}/masmovil/v1/orders/ovid/status`,
  },
}
